import React, { useState, useRef } from 'react';
import { useOnClickOutside } from 'usehooks-ts';
import { Transition } from '@headlessui/react';
import classNames from 'classnames';
import { filter as _filter, isEmpty } from 'lodash';
import videojs from '@atoms/Video';
import { useMobxStores } from '@stores/store';

const DefaultSelectBox = ({ options, name, onChangSelect, value, sId }) => {
  const ref = useRef(null);

  const [isOpen, setIsOpen] = useState(false);
  const [selectId, setSelectId] = useState(sId ? sId : options[0].id);
  const [selectName, setSelectName] = useState(
    value && _filter(options, (v, i) => v.id === value).length > 0
      ? _filter(options, (v, i) => v.id === value)[0].name
      : options[0].name
  );

  let index = 0;
  React.useEffect(() => {
    setSelectId(sId);
    setSelectName(value);
  }, [value, options, name]);

  useOnClickOutside(ref, () => setIsOpen(false));

  const handleOptionSelect = (value, name) => {
    setIsOpen(false);
    setSelectId(value);
    setSelectName(name);
    if (onChangSelect) {
      onChangSelect(value);
    }
  };

  return (
    <div ref={ref} className="select-wrapper flex-initial w-100">
      <label className="sr-only">Select a tab</label>
      <div className="relative">
        <div onClick={() => setIsOpen(!isOpen)}>
          <div className="bg-white font-notoSans leading-none block w-full focus:outline-none focus:shadow-none focus:ring-0 focus:border-primary border-[#e6eaf2] text-[14px] pl-[26px] py-[10px]  pr-[43px] text-[#333] focus:text-black border relative ">
            <i className="icon-arrow absolute right-[17px] top-1/2 -translate-y-1/2" />
            {selectName}
          </div>
        </div>
        <Transition
          show={isOpen}
          leave="transition ease-in duration-100"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
          className={classNames(
            'select-list-box absolute z-10 w-full bg-white shadow-lg max-h-60  text-base ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none sm:text-sm mt-1'
          )}
        >
          <ul
            tabIndex="-1"
            role="listbox"
            aria-labelledby="listbox-label"
            aria-activedescendant="listbox-option-3"
          >
            {options.map(({ id, name }) => {
              const isSelect = selectId === id;
              return (
                <li
                  key={`options_${id}`}
                  className={classNames(
                    'text-[#616161] cursor-default select-none text-center relative py-2 group border-b border-x border-[#f1f1f1]',
                    'hover:font-bold ',
                    {
                      'bg-[#b99ef9]': isSelect,
                    },
                    {
                      '!text-[#fff]': isSelect,
                    }
                  )}
                  role="option"
                  onClick={() => handleOptionSelect(id, name)}
                >
                  <span className={classNames('block truncate')}>{name}</span>
                </li>
              );
            })}
          </ul>
        </Transition>
      </div>
    </div>
  );
};

export default DefaultSelectBox;
